export const SortUp = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clip-path="url(#clip0_2370_7260)">
      <path
        d="M16.0001 15.3332C16.0001 15.7019 15.7014 15.9999 15.3334 15.9999H6.66673C6.29873 15.9999 6.00006 15.7019 6.00006 15.3332C6.00006 14.9646 6.29873 14.6666 6.66673 14.6666H15.3334C15.7014 14.6666 16.0001 14.9646 16.0001 15.3332ZM6.00006 11.9999C6.00006 12.3686 6.29873 12.6666 6.66673 12.6666H13.3334C13.7014 12.6666 14.0001 12.3686 14.0001 11.9999C14.0001 11.6312 13.7014 11.3332 13.3334 11.3332H6.66673C6.29873 11.3332 6.00006 11.6312 6.00006 11.9999ZM6.00006 8.66657C6.00006 9.03524 6.29873 9.33324 6.66673 9.33324H11.3334C11.7014 9.33324 12.0001 9.03524 12.0001 8.66657C12.0001 8.29791 11.7014 7.99991 11.3334 7.99991H6.66673C6.29873 7.99991 6.00006 8.29791 6.00006 8.66657ZM6.00006 5.33324C6.00006 5.70191 6.29873 5.99991 6.66673 5.99991H9.33339C9.70139 5.99991 10.0001 5.70191 10.0001 5.33324C10.0001 4.96457 9.70139 4.66657 9.33339 4.66657H6.66673C6.29873 4.66657 6.00006 4.96457 6.00006 5.33324ZM6.08073 2.19524L4.27539 0.389238C3.75606 -0.128762 2.91073 -0.129428 2.39006 0.389238L0.585393 2.19524C0.324726 2.4559 0.324726 2.87724 0.585393 3.1379C0.846059 3.39857 1.26806 3.39857 1.52806 3.1379L2.66673 1.99924V15.3332C2.66673 15.7019 2.96539 15.9999 3.33339 15.9999C3.70139 15.9999 4.00006 15.7019 4.00006 15.3332V1.99924L5.13806 3.1379C5.26806 3.2679 5.43873 3.33324 5.60939 3.33324C5.78006 3.33324 5.95073 3.2679 6.08073 3.1379C6.34139 2.87724 6.34139 2.4559 6.08073 2.19524Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_2370_7260">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
